module.exports = "https://preprod.web-phone.apps.phone.com/static/media/IAB_logo.c4b833a9.png";